/* eslint-disable react/prop-types */
import { farmReportApi } from 'api/endpoints/farm';
import React, { useEffect, useState } from 'react';
import MapModel from 'screens/common/dynamicForm/dynamicNormalForm/FormFields/Mapmodel';
function ViewComponent({ farmerId, onClose }) {
  const [mapData, setMapData] = useState(null); // State for map data
  const [data, setData] = useState(null); // State for map data
  const tns_tenant = '03534add672340809e2c70314b1ce20e';

  const fetchFormData = async () => {
    let id = farmerId;
    let isEdit = true;
    try {
      const formResponse = await farmReportApi.getDynamicFarmForm(isEdit, id);
      const formSchema = formResponse.data.results;

      const editResponse = await farmReportApi.getDynamicFarmForm(isEdit, id);

      if (editResponse?.data?.results) {
        const updatedFields = formSchema.fields.map(field => {
          if (field.table) {
            // Handle table field, replace rows with the data from the edit response
            const tableData = editResponse.data.results[field.id] || [];
            return {
              ...field,
              table: {
                ...field.table,
                rows: tableData.length > 0 ? tableData : field.table.rows // Replace with editResponse rows if available
              }
            };
          } else {
            return {
              ...field,
              defaultValue:
                editResponse.data.results[field.id] || field.defaultValue
            };
          }
        });

        formSchema.fields = updatedFields;
        setData(formSchema);

        // Assuming you need to pass geoJSON data to the MapModel
        const geoJsonData = editResponse.data.geoJson || {}; // Replace with actual field
        setMapData(geoJsonData);
      }
    } catch (error) {
      console.error('Error fetching form data:', error);
    }
  };

  useEffect(() => {
    if (farmerId) {
      fetchFormData(); // Fetch data when farmerId is passed
    }
  }, [farmerId]);

  return (
    <div>
      {data?.fields.map((item, index) => (
        <div key={index}>
          {item.type === 'coordinates' && (
            <MapModel
              key={farmerId}
              showModal={true}
              setShowModal={onClose} // Close modal when needed
              mode="polygon"
              uploadedGeoJSONLayer={item.defaultValue} // Pass the geoJSON data to the map model
              onLocationSelect={() => {}}
              isMapEditable={false}
            />
          )}
        </div>
      ))}
    </div>
  );
}

export default ViewComponent;
